import { IOrgUserVariable, IOrgUserVariableOverride } from 'types/domain/user';
import { IVariableDAO, IVariableOption, VariableType } from 'types/domain/variable';
import { CheckIcon } from '@heroicons/react/24/outline';
import { ICourseVariableDAO } from 'types/domain/course';

export function isVariableComplete(
  variable: ICourseVariableDAO,
  userVar: IOrgUserVariable,
  userVarOver: IOrgUserVariableOverride,
): boolean {
  switch (variable.variable.type) {
    case VariableType.BOOLEAN:
      return userVarOver ? userVarOver.pass : userVar ? userVar.pass : false;
    case VariableType.OPTIONS:
      return userVarOver
        ? userVarOver.variableOptionId === variable.variableOptionId
        : userVar
        ? userVar.variableOptionId === variable.variableOptionId
        : false;
    case VariableType.SCORE:
      return userVarOver ? userVarOver.value >= variable.value : userVar ? userVar.value >= variable.value : false;
  }
}

export function getVariableOptionName(variable: IVariableDAO, variableOptionId): string {
  if (!variable) return null;

  return variable.options?.find(opt => opt.id === variableOptionId)?.name;
}
